import React, { useState, useEffect, useCallback } from 'react';
import { Container, Card } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { SearchAndFilterBar } from '../components/search-and-filter-bar';
import auditApi from '../api/auditApi';
import AuditTimeline from '../components/audit/AuditTimeline';
import UserAuditSummary from '../components/audit/UserAuditSummary';
import './UserAudit.scss';

const UserAudit = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const { getThemeColors } = useTheme();
  const colors = getThemeColors();

  const [auditData, setAuditData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    from: null,
    to: null,
    action: '',
    entityType: '',
    search: ''
  });
  const [searchTerm, setSearchTerm] = useState('');

  // Debounced search
  useEffect(() => {
    const timer = setTimeout(() => {
      setFilters(prev => ({ ...prev, search: searchTerm }));
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  // Fetch audit data
  const fetchAuditData = useCallback(async () => {
    if (!userId) return;

    setLoading(true);
    setError(null);

    try {
      const params = {
        ...filters,
        limit: 100,
        offset: 0
      };

      const response = await auditApi.getUserTimeline(userId, params);

      if (response?.data?.success && response?.data?.data) {
        setAuditData(response.data.data);
      } else {
        throw new Error('Failed to load audit data');
      }
    } catch (err) {
      console.error('Error fetching audit data:', err);
      setError(err.message || 'Failed to load audit data');
    } finally {
      setLoading(false);
    }
  }, [userId, filters]);

  useEffect(() => {
    fetchAuditData();
  }, [fetchAuditData]);


  if (loading && !auditData) {
    return (
      <Container fluid style={{ backgroundColor: colors.background, minHeight: '100vh' }}>
        <div style={{ padding: '20px', textAlign: 'center' }}>
          Loading user activity...
        </div>
      </Container>
    );
  }

  return (
    <Container fluid style={{ backgroundColor: colors.background, minHeight: '100vh' }}>
      <div className="user-audit-page">
        <div className="user-audit-page__header">
          <button
            type="button"
            className="user-audit-page__back"
            onClick={() => navigate(-1)}
          >
            ← Back
          </button>
          <h1>User Activity Timeline</h1>
        </div>

        {auditData?.summary && <UserAuditSummary summary={auditData.summary} />}

        {/* Filters */}
        <SearchAndFilterBar
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          onFilterClick={() => {}}
          searchPlaceholder="Search by order ID, field name..."
          pageType="users"
          disableAddModal
        />

        {/* Timeline */}
        {auditData?.timeline && (
          <AuditTimeline events={auditData.timeline} />
        )}

        {error && (
          <div className="statistics-error">
            Error: {error}
          </div>
        )}
      </div>
    </Container>
  );
};

export default UserAudit;
